var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',{staticClass:"bunt-dialog-container"},[_c('div',{staticClass:"bunt-dialog"},[_vm._t("default")],2),_c('div',{staticClass:"bunt-backdrop",attrs:{"keyup.esc":"close"},on:{"click":_vm.close}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }